export default {
  'error-unable-process-payment': 'Unable to process the payment. The amount for the selected payment methods is higher than the transaction value.',
  'payment-type-label': {
    'prepayment': 'Deposit',
    'credit-card': 'Credit card',
    'cash': 'Cash',
    'check': 'Check',
    'gift-card': 'Gift Card',
    'subscription': 'Subscription',
    'paypal': 'Paypal',
    'store-credit': 'Store Credit',
    'american-express': 'American Express',
    'bank-transfer': 'Bank Transfer',
    'egift-card': 'Gift Card',
    'membership': 'Membership card',
    'package': 'Package',
    'split': 'Split payment',
    'card': 'Card (Mobile Payment)',
    'booksy_pay': 'Booksy Pay',
    'booksy-gift-card': 'Booksy Gift Card',
  },
  'quick-sale': {
    'suggested-client': 'Suggested for this client',
    'popular-items': 'Popular items',
    'no-results': 'No items for Quick Sale',
    'no-results-description': 'Your most popular products and services will be listed here',
  },
  appointments: {
    'search-placeholder': 'Search...',
    'disabled-header': 'Appointment Already Selected',
    'disabled-subheader': 'You can only checkout one appointment at a time.<br/>To checkout a different appointment, please remove the current one from the cart.',
    'client-appointments': 'This client appointments',
    'client-turns': 'This client turns',
    'all-turns': 'All turns',
    'today': 'Today',
    'yesterday': 'Yesterday',
    'no-results': 'No appointments to charge',
    'no-results-description': 'It looks like all of your appointments have been checked out already.',
    'no-results-search': 'No Results Found',
    'no-results-search-description': 'Check your spelling and try again!',
    'no-results-cancellations': 'No fees to charge',
    'no-results-cancellations-description': 'It looks like all of your cancellation fees have been processed.',
    'no-results-turns': 'No turns to charge',
    'no-results-turns-description': 'It looks like all of your turns have been checked out already.',
    'sales': 'Appointments',
    'unfinished': 'Unfinished',
    'cancellations': 'Cancellation fees',
  },
  'failed-transaction-modal': {
    'title': 'Transaction failed!',
    'description': 'The issued bank did not approve this action. Please check the card details or, if problem persists, try a different card.',
    'try-charge-again': 'Try to charge again',
    'abort-online-payment': 'Cancel payment',
  },
  'incomplete-transaction-modal': {
    'title': 'Transaction Incomplete',
    'description': 'This transaction is taking too long to process. We recommend trying to process it again, or cancelling it and using a different payment method.',
    'try-again': 'try again',
    'cancel': 'cancel',
  },
  services: {
    'search-placeholder': 'Search services...',
    'no-results': 'No services.',
    'search-no-results-description': 'No services match your criteria.',
  },
  'basket': {
    'empty-checkout-title': 'Cart is empty',
    'empty-checkout-description': 'Select items that you would like to add to the cart.',
    'current-register': 'Current cash register',
    'items': 'Items',
    'item': 'Item',
    'assign-sale': 'Assign Sale',
    'consumption': 'Usage ({count} product) | Usage ({count} products) | Usage ({count} products)',
    'consumption-empty': 'Usage',
    'amount': 'Amount',
    'tap-item': 'Tap item to change',
    'subtotal': 'Subtotal',
    'taxes-fees': 'Taxes & Fees',
    'platform-fee': 'Platform Fee',
    'discount': 'Discount',
    'discount-or-promocode': 'Discount or Promocode',
    'tip': 'Tip',
    'total': 'Total',
    'charge': 'Charge',
    'select-payment-method': 'Select payment method',
    'confirm-and-pay': 'Confirm and pay',
    'complete-payment': 'Complete payment',
    'continue': 'Continue',
    'delete-cancellation-fee': 'Delete Cancellation Fee',
    'title': 'Checkout',
    'search-item-label': 'Search item...',
    'select-client': 'Select a client',
    'search-client': 'Search by name or phone number...',
    'add-new-client': 'Add new client',
    'menu-turns': 'Turns',
    'menu-quick-sale': 'Quick Sale',
    'menu-appointments': 'To be charged',
    'menu-services': 'Services',
    'menu-addons': 'Add-ons',
    'menu-products': 'Products',
    'menu-gift-cards': 'Gift Cards',
    'menu-packages': 'Packages',
    'menu-memberships': 'Memberships',
    'menu-custom-amount': 'Custom Amount',
    'disabled-header': 'Additional items cannot be added until the current one is checked out.',
    'disabled-subheader': 'You can remove any item by tapping on it.',
    'cancel-deposit-title': 'Delete cancellation fee from this appointment?',
    'cancel-deposit-description': 'You will not be able to charge cancellation fee for this appointment anymore.',
    'cancel-deposit-resolve-btn': 'Yes, delete',
    'cancel-deposit-reject-btn': 'No, go back',
    'edit-transaction': 'Edit Transaction',
    'edit-transaction-title': 'You can edit the transaction now',
    'edit-transaction-desc': 'Change the transaction items or add new one.',
    'other-payment-methods': 'Other payment methods',
    'charge-card-on-file': 'Charge card on file',
    'client-removed-payment-method': 'This client has removed their payment method',
    'charge-booksy-gift-card': 'Checkout with gift card',
    'amount-from-booksy-gift-card': '{amount} will be checked out with Booksy gift card',
    'pending-payment-amount': 'Pending payment {amount}',
  },
  'consumption': {
    'title': 'Product Usage',
    'issued-by': 'Issued by',
    'approved-by': 'Approved by (optional)',
    'note': 'Note (optional)',
    'items': 'Items',
    'add-item': 'Add item',
    'storage-location': 'Storage location',
    'quantity': 'Quantity',
    'product': 'Product',
    'load-from-appointment': 'Load from appointment',
    'load-from-appointment-description': 'There are already products on the list. <br/>What do you want to do next?',
    'add-products-to-list': 'Add products to the list ',
    'replace-existing-list': 'Replace the existing list',
  },
  'empty-cash-registers': {
    'cash-registers-open-required': 'To make a sale, please open the register first',
    'open-register': 'Open register',
    'cash-registers-selected-required': 'To make a sale, please select register',
    'select-register': 'Select register',
  },
  'select-register-modal': {
    title: 'Select cash register',
    'open': 'Open',
    'total': 'Total',
    'opening': 'Opening',

  },
  'basket-discount-modal': {
    title: 'Discount',
    'discount-amount': 'Discount amount (%)',
  },
  'basket-row-modal': {
    'edit-item': 'Edit Item',
    quantity: 'Quantity',
    'item-discount': 'Item discount (%)',
    price: 'Price',
    'discount-amount': 'Discount amount',
  },
  'staff-commission-modal': {
    'staff-member': 'Staff Member',
    'nobody': 'No commission',
    'commissions': 'Commissions',
  },
  'basket-row': {
    discount: 'Discount',
  },
  'customer-card': {
    'select-client': 'Select client or leave empty for walk-in',
    'walk-in': 'Walk-in',
    'label': {
      'payment-card-on-file': 'Card on file',
      'autopay-enabled': 'Card on file - Autopay',
    },
  },
  'custom-amount': {
    'amount': 'Amount',
    'description': 'Description',
    'btn-add': 'Add to cart',
  },
  'categories-list': {
    title: 'Categories',
  },
  'search': {
    'recently-searched': 'Recently searched',
    'no-results': 'No results found...',
    'no-results-description': 'Try type service name, product.',
  },
  'product': {
    'products': 'Products',
    'in': 'in',
  },
  'products': {
    'search-placeholder': 'Search products by name or scan bar code...',
    'search-no-results-description': 'No products match your criteria.',
    'no-results': 'No products added',
    'no-results-description': 'You don\'t have any products available to sell',
  },
  'service-variant': {
    'services': 'Services',
    'in': 'in',
    'combo': 'Combo',
  },
  addons: {
    'search-placeholder': 'Search add-ons...',
    'no-results': 'No add-ons added',
    'search-no-results-description': 'No add-ons match your criteria.',
    'add-to-basket': 'Add to basket',
    'price': 'price',
    'quantity': 'qty',
  },
  vouchers: {
    'gift-card-no-results': 'No gift cards added',
    'gift-card-no-results-description': 'You don\'t have any Gift Cards available to sell',
    'gift-card-empty-results-description': 'No Gift Cards match your criteria',
    'gift-card-search-placeholder': 'Search gift cards...',
    'membership-no-results': 'No memberships added',
    'membership-no-results-description': 'You don\'t have any Memberships available to sell',
    'membership-empty-results-description': 'No Memberships match your criteria',
    'membership-search-placeholder': 'Search memberships...',
    'package-no-results': 'No packages added',
    'package-no-results-description': 'You don\'t have any Packages available to sell',
    'package-empty-results-description': 'No Packages match your criteria',
    'package-search-placeholder': 'Search packages...',
    'expiration': 'Expiration',
    'valid-for': 'Valid for',
    'services': 'services',
    'all-services': 'All services',
  },
  'form-voucher-modal': {
    'add-to-checkout': 'Add to Cart',
    'value': 'Value',
    'price': 'Price',
    'valid-from': 'Valid from',
    'valid-till': 'Valid Until',
    'expiration': 'Expiration',
    'valid-for': 'Valid services',
    'services': 'services',
    'service': 'service',
    'no-services-added': 'No services added.',
    'never': 'Never',
    'all-services': 'All services',
    'owner-name': 'Owner name',
    'client-name': 'Client name',
    'recipient-name': 'Recipient name',
  },
  'customer-input-search': {
    'client-name': 'Client name',
    'client-name-placeholder': 'Search by name or phone number...',
  },
  'payment-voucher': {
    'header': 'Pay with a',
    'giftcard-label': 'Redeem Amount',
    'membership-redeem': 'Membership redeem',
    'giftcard-redeem': 'Giftcard redeem',
    'package-redeem': 'Package redeem',
    'due-to': 'Due',
    'finish': 'Finish',
    'continue': 'Continue',
  },

  'gratuity': {
    'tip': 'Tip',
    'custom': 'Custom',
    'custom-tip': 'Custom Tip',
    'equal': 'Equal',
  },
  'gratuity-split-modal': {
    header: 'Tip Split',
    staffer: 'Staffer',
    split: 'Split',
    percentage: 'Percentage (%)',
    equal: 'Equal',
    'add-staffer': 'Add Staffer',
    'must-equal-hundred': 'Percentage values must add up to 100',
    'assign-remaining-split-info': 'Click a staff member name to assign the remaining tip.',
  },

  paid: {
    'change': 'change',
    'out-of': 'out of',
    'btn-sent-receipt': 'Show Receipt',
    'btn-calendar': 'Go to calendar',
    'btn-new-sale': 'Start new sale',
    'btn-back-to-payment-method': 'Back to Payment Method',
    'btn-retry-payment': 'Retry payment',
    'btn-generate-invoice': 'Issue an Invoice',
    'btn-go-to-invoice': 'Show an Invoice',
    'receipt-sent': 'Receipt sent',
    'checkout-complete': 'Checkout complete!',
  },
  'checkout-complete': {
    'title': 'Checkout complete!',
    'btn-resolve': 'Go to Transactions',
  },
  'payment-choices': {
    'warning-text': 'Select the payment method you’d like to use to cover the remaining amount due.',
  },
  'payment-type-choices': {
    'unavailable-client': 'Unavailable for this client',
    bcr: {
      'unavailable': 'Disconnected',
      connect: 'Connect',
      'connection-succeed': 'Connected to {label}',
      'searching-devices': 'Searching devices',
      'searching-description': 'I\'m creating a list of your devices that are nearby.<br />This may take a while.',
      'choose-reader': 'Choose your primary reader',
      'choose-description': 'The selected reader will be your primary reader and will be the one you will connect to first when selecting this payment menthod. If you want to change the primary reader, you can do so in the payment settings.',
      'choose-available': 'Available to connect',
      'choose-other': 'Other devices',
      'choose-button': 'Choose',
      'permission': {
        location: 'In order to process payments with Booksy Card Reader, you must allow Booksy to access location while using the app. Go to the tablet settings and give Booksy access to location.',
        bluetooth: 'In order to process payments with Booksy Card Reader, you must allow Booksy to access bluetooth while using the app. Go to the tablet settings and give Booksy access to bluetooth.',
      },
    },
    'platform-fee': 'Your client covers {fee} platform fee for online payments',
  },
  'cash-drawer': {
    header: 'Cash Drawer',
    equal: 'Equal',
    tip: 'Tip',
    change: 'Change',
    'cash-received': 'Cash Received',
    'cash-received-error-msg': 'Cash received is less than total amount',
  },
  'pay-by-app': {
    header: 'Charging card...',
    'description': 'Most payments process automatically. If the client needs to approve this charge, they’ll see a request in their app',
    'abort-txt': 'Cancel payment',
  },
  'keyed-in-payment': {
    header: 'Processing payment',
    'card-modal': {
      'title': 'Keyed In Payment',
      'text': 'Collect payment for bookings by manually entering client’s card details.',
      'card-data-disclaimer': 'By selecting <strong>charge card now</strong>, you confirm you have the client’s authorization to charge their card.',
      'safe-payment-with-stripe': 'Guaranteed <strong>SAFE</strong> checkout powered by',
      'empty-error-message': 'Field cannot be empty',
      'actions': {
        'submit': 'Charge card now',
        'cancel': 'Go back',
      },
    },
  },
  'payment-details': {
    'header': 'Payment Method & Tip',
    'payment-method': 'Payment method',
    'payment': 'Payment',
    'change': 'Change',
    'remaining': 'Remaining',
    'remaining-error': 'Payment rows are not summing up to transaction total',
    'remaining-split-error': 'Split payment rows are not summing up to transaction total',
    'amount': 'Amount',
    'add': 'Add Payment Method',
    'pcs': 'Pcs',
    'reader-tip-info': 'The total amount may vary, depending on the Tip selected by the client on Card Reader.',
  },
  'blik': {
    'modal': {
      'title': 'Enter the 6-digit BLIK code',
      'text': 'Enter the BLIK code or allow your client to do so',
      'placeholder': 'Blik code',
      'message': 'Clients can find the BLIK code in their banking app.',
      'to-short-code': 'BLIK code is too short',

      'actions': {
        'submit': 'Complete payment with blik',
        'cancel': 'Go back',
      },
    },
    'checkout': {
      'text': 'Ask the client to confirm the payment in their banking app',
    },
  },
  'payment-choices-modal': {
    header: 'Payment Method',
  },
  'find-voucher-modal': {
    header: 'Find a Card',
    'tab-card-number': 'By Card Number',
    'tab-client': 'By Client',
    'giftcard-label': 'Redeem Amount',
    'due-to': 'Due to',
    'search-placeholder-client': 'Search by name or phone number...',
  },
  'voucher-search': {
    'search-placeholder-card-number': 'Type number or scan card...',
    'no-search-results': 'No results found.',
  },
  'exit-checkout-modal': {
    'title': 'Cancel sale?',
    'description': 'If you cancel this sale the transaction will not be processed.',
    'clear-sale': 'Cancel Sale',
    'cancel': 'Go Back',
  },
  'delete-transaction-modal': {
    'title': 'Delete Transaction?',
    'description': 'You are about to delete the transaction and all its details.<br/> Please note, the payments are not automatically refunded.',
    'delete-transaction': 'Yes, delete the transaction',
    'cancel': 'Oops, go back',
  },
  'header': {
    'btn-cancel': 'Cancel sale',
  },
  'booksy-card': {
    'follow-instructions': 'Follow the instructions on your terminal',
    'insert-card': 'Tap, swipe or insert card',
    'connecting': 'Connecting...',
    'verifying': 'Verifying payment details',
    'processing': 'Processing payment',
  },
  'bsx': {
    'errors': {
      'unavailable': 'Could not connect to Booksy POS. Please check if the program is running and try again.',
      'timeout': 'Booksy POS connection has timed out. Please check if the program is running and try again.',
      'printer-disconnected': 'Fiscal printer has not been connected to Booksy POS. Please connect the printer and try again.',
      'generic': 'Something went wrong when trying to communicate with Booksy POS. Please check the program for detailed logs.',
      'receipt-already-printed': 'The receipt has already been printed out. Please use Booksy POS to print it again or edit the transaction and print a new receipt.',
      'empty-receipt': 'Booksy POS has not printed out a valid receipt.',
      'invalid-status': 'Failed to print out the receipt. Error code: ',
      'invalid-response': 'Booksy POS has yielded an invalid response.',
    },
    'receipt-printed': 'Receipt printed successfully.',
    'monthly-report-queued': 'Monthly report printout has been successfully requested.',
    'daily-report-printed': 'Daily report printout has finished successfully.',
  },
  splash: {
    'try-bcr': {
      title: 'The Better Way To Get Paid',
      'booksy-card-reader': 'Booksy Card Reader',
      paragraph1: {
        part1: 'Spend less time chasing payments and more time doing what you love. <b>Booksy Card Reader</b> lets you process credit card and mobile wallet payments on the spot. It\'s quick, secure and easy.',
        part2: '',
      },
      paragraph2: '<b>Booksy Card Reader</b> is fully integrated with your Booksy App, offering a seamless experience from checkout to reporting so you can keep your rhythm, even when you\'re bouncing between appointments.',
      pros: {
        pro1: 'Hardware choices to fit your business needs',
        pro2: 'Simple set up',
        pro3: 'Low, transparent processing fees',
        pro4: 'One app for everything',
      },
      'get-bcr': 'Get Booksy Card Reader',
    },
    activation: {
      title: 'Businesses are making <em>16% more</em> with Booksy Card Reader.',
      more: '',
      paragraph1: {
        part1: 'You\'ve got your new Booksy Card Reader in-hand. Now it\'s time to get in on the action.',
      },
      pros: {
        pro1: 'Expect funds in your bank account the next business day*',
        pro2: 'Use Fast Payouts for a flat 1% fee to get your money within 30 minutes',
        pro3: 'Your transaction history and payment details, all in one place',
        pro4: 'Give clients the convenience to pay how they want',
      },
      annotation: '* Some exclusions may apply',
      'connect-bcr': 'Connect Booksy Card Reader',
    },
    tease: 'Are you ready to take control of your money?',
  },
  'tax-modal': {
    title: 'Missing Tax Info',
    description: 'To check out an appointment and issue a receipt, you need to add Tax Info to your Business Details.',
    'add-tax-info-btn': 'Add Tax Info',
  },
}
